import { SearchData } from '../../../common/types/search'

export const hasAnyResults = (data: SearchData | undefined): boolean => {
  if (!data) return false
  return Object.values(data).some((arr) => Array.isArray(arr) && arr.length > 0)
}
